import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import "./add-details.css";
import { connect } from "react-redux";
import IGPDetail from "./IGPDetail";
import AddIGP from "./AddIGP";
import IGPReport from "./IGPReport";
import { isNull } from "lodash";

const IGP = (props) => {
    const permissions = JSON.parse(localStorage.getItem("permissions"));

    return (
        <>
            <Tabs
                defaultActiveKey={!isNull(permissions) && permissions.some(p => p['sub_id'] === 14) ?
                    "IGPList" : !isNull(permissions) && permissions.some(p => p['sub_id'] === 15) ?
                        "AddIGP" : !isNull(permissions) && permissions.some(p => p['sub_id'] === 16) ?
                            "IGPReport" : ""}
                id="IGPList"
                className="mb-3"
                unmountOnExit={true}>
                <Tab
                    eventKey="IGPList"
                    title="IGP Detail"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 14) ? false : true}>
                    <IGPDetail />
                </Tab>
                <Tab
                    eventKey="AddIGP"
                    title="Add IGP"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 15) ? false : true}>
                    <AddIGP />
                </Tab>

                <Tab
                    eventKey="IGPReport"
                    title="IGP Report"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 16) ? false : true}>
                    <IGPReport />
                </Tab>
            </Tabs>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};
const mapStateToProps = (state, ownProps) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IGP);